import { hasCapability } from "@/utils/capability";

import { useActiveScopeCapabilities } from "../capability/useActiveScopeCapabilities";

/**
 * Team surfaces (`TEAM:READ` to see, `TEAM:WRITE` to create/edit/delete) checked
 * against the active scope's capability set. Strict RBAC — the backend resolver
 * is the single source of truth and the S0 grants give every legacy member the
 * matching keys. See docs/capabilities.md.
 */
export const useTeamPermissions = () => {
  const { capabilities } = useActiveScopeCapabilities();

  const canSeeTeams = hasCapability(capabilities, "TEAM:READ");
  const canManageTeams = hasCapability(capabilities, "TEAM:WRITE");

  return { canSeeTeams, canManageTeams };
};
